module.exports = {
	Polygon: require("./Polygon").default,
}


//////////////////
// WEBPACK FOOTER
// ./lib/starling/geom/index.js
// module id = 327
// module chunks = 0